var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5978 12.0144H1.98645C1.47112 12.0325 0.98293 12.2499 0.624757 12.6208C0.266585 12.9918 0.0664063 13.4873 0.0664062 14.003C0.0664063 14.5186 0.266585 15.0141 0.624757 15.3851C0.98293 15.756 1.47112 15.9734 1.98645 15.9915H12.5978C13.1131 15.9734 13.6013 15.756 13.9595 15.3851C14.3177 15.0141 14.5178 14.5186 14.5178 14.003C14.5178 13.4873 14.3177 12.9918 13.9595 12.6208C13.6013 12.2499 13.1131 12.0325 12.5978 12.0144Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0118 6.00598H1.98645C1.47112 6.02405 0.98293 6.24147 0.624757 6.61242C0.266585 6.98338 0.0664062 7.47889 0.0664062 7.99454C0.0664062 8.51018 0.266585 9.0057 0.624757 9.37665C0.98293 9.7476 1.47112 9.96502 1.98645 9.98309H20.0118C20.5271 9.96502 21.0153 9.7476 21.3735 9.37665C21.7317 9.0057 21.9318 8.51018 21.9318 7.99454C21.9318 7.47889 21.7317 6.98338 21.3735 6.61242C21.0153 6.24147 20.5271 6.02405 20.0118 6.00598Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.0127 0H1.98733C0.889759 0 0 0.889759 0 1.98733V1.98978C0 3.08735 0.889759 3.97711 1.98733 3.97711H20.0127C21.1102 3.97711 22 3.08735 22 1.98978V1.98733C22 0.889759 21.1102 0 20.0127 0Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectIcon);
export default __webpack_public_path__ + "static/media/subjectIcon.93b87acf1bf9d6dba88cf7838735cb03.svg";
export { ForwardRef as ReactComponent };